<template>
<div>
    <h1 class=" subtitle">Ordenes de Compra o Servicio</h1>
    <div class="nj-panel">
        <div class="nj-panel-content">
            <div class="nj-grid">
                <InputSimpleSelect v-model="type" label="Tipo de orden" :source="tipos_orden" itemKey="id" itemValue="id" :labelFunction="(item) => item.nombre" @change="refreshData()">
                </InputSimpleSelect>
                <InputSimpleSelect v-model="status" label="Estado" :source="ordenEstado" itemKey="id_orden_estado" itemValue="id_orden_estado" :labelFunction="(item) => item.descripcion"
                    @change="refreshData()"></InputSimpleSelect>
                <InputSimpleSelect v-model="coc_id" label="Condicion comercial" :source="condiciones_comerciales" itemKey="coc_id" itemValue="coc_id" :labelFunction="(item) => item.coc_descripcion"
                    @change="refreshData()">
                </InputSimpleSelect>
                <InputText label="Año" v-model="year" @enter="refreshData()" placeholder="año"></InputText>
                <InputText label="Orden" v-model="search" @enter="searchData()" placeholder="buscar"></InputText>
            </div>
            <br>
            <div class="nj-flex">
                <router-link data-action="new" to="/orden/new" class="button is-success" title="Nueva Orden">
                    <b-icon icon="plus" size="is-small" style="color: white"></b-icon>
                </router-link>
                <router-link data-action="new" to="/orden/massive" class="button is-warning" title="Carga Masiva">
                    <b-icon icon="upload" size="is-small"></b-icon>
                </router-link>
                <Button icon="doc" label="Reporte" @click="show_reporte_1 = true"></Button>
                <Button icon="doc" label="Reporte OC-OP" @click="popup({ interfaz: 'OrdenCompraReporte2', activar: true })"></Button>
            </div>
            <br>
            <b-table :data="data" :loading="loading" paginated backend-pagination bordered :total="total" :per-page="perPage" aria-next-label="Siguiente" aria-previous-label="Anterior"
                aria-page-label="Pág." aria-current-label="Pág. actual" backend-sorting :default-sort-direction="'desc'" :default-sort="['codigo', 'desc']" @page-change="onPageChange">
                <template slot-scope="props">
                    <b-table-column field="codigo" label="Código" header-class="is-info">{{ props.row.codigo }}</b-table-column>
                    <b-table-column field="fecha_orden" label="Fecha Orden" header-class="is-info">{{ props.row.fecha_orden }}</b-table-column>
                    <b-table-column field="creado_por" label="Creado Por" header-class="is-info">{{ props.row.creado_por }}</b-table-column>
                    <b-table-column field="proveedor" label="Proveedor" header-class="is-info">{{ props.row.proveedor }}</b-table-column>
                    <b-table-column field="centro_costo" label="Centro de Costo" header-class="is-info">{{ props.row.centro_costo }}</b-table-column>
                    <b-table-column field="estado" label="Estado" header-class="is-info">
                        <span class="tag" :class="getOrdenColor(props.row.estado)">{{ props.row.estado }}</span>
                    </b-table-column>
                    <b-table-column field="condicion_comercial" label="Condición" header-class="is-info">{{ props.row.condicion_comercial }}</b-table-column>
                    <b-table-column field="es_importacion" label="Importación" header-class="is-info">
                        <b-icon title="Nacional" v-if="!props.row.es_importacion" icon="flag" type="is-success"></b-icon>
                        <b-icon title="Internacional" v-else icon="earth" type="is-info"></b-icon>
                    </b-table-column>
                    <b-table-column label="" header-class="is-info">
                        <a :href="'/orden/view/' + props.row.id" title="Información"><span class="icon has-text-info">
                                <i class="mdi mdi-information mdi-18px"></i> </span></a>
                        <a v-if="props.row.es_editable && !isVisualizador()" :href="'/orden/edit/' + props.row.id" title="Modificar">
                            <span class="icon has-text-info">
                                <i class="mdi mdi-circle-edit-outline mdi-18px"></i>
                            </span>
                        </a>
                        <a href="#" @click.prevent="downloadFile(props.row)" title="Descargar">
                            <span class="icon has-text-success">
                                <i class="mdi mdi-download mdi-18px"></i>
                            </span>
                        </a>
                        <a href="#" @click.prevent="notifyOrden(props.row.id)" title="Notificar"><span class="icon has-text-info">
                                <i class="mdi mdi-email mdi-18px"></i>
                            </span>
                        </a>
                        <a v-if="props.row.es_pagable" :href="'/orden/pagos/' + props.row.id" title="Pagos">
                            <b-icon icon="cash-100" type="is-success"></b-icon>
                        </a>
                        <a v-if="props.row.es_importacion" :href="'/orden/importacion/' + props.row.id" title="Actualizar Estado">
                            <b-icon icon="update" type="is-success"></b-icon>
                        </a>
                        <a :href="'/orden/restart/' + props.row.id + '?code=' + props.row.codigo" title="Actualizar Estado">
                            <b-icon icon="refresh" type="is-danger"></b-icon>
                        </a>
                        <!-- <button class="nj-button c-green" v-if="showPagar(props.row)" @click="pagarOrden"><i class="mdi mdi-content-save"></i>Pagar</button> -->
                        <a v-if="!isVisualizador()" href="#" @click.prevent="deleteOrden(props.row.id)" title="Eliminar">
                            <span class="icon has-text-danger">
                                <i class="mdi mdi-delete mdi-18px"></i>
                            </span>
                        </a>
                    </b-table-column>
                </template>
                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>No se encontraron Ordenes</p>
                        </div>
                    </section>
                </template>
            </b-table>
            <b-modal :active.sync="show_reporte_1">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">REPORTE</p>
                    </header>
                    <section class="modal-card-body">
                        <b-tabs v-model="reporte.tipo_reporte">
                            <b-tab-item label="Centro de Costo">
                                <b-field label="Centro de Costo">
                                    <b-select multiple native-size="7" v-model="reporte.centro_costos" expanded>
                                        <option v-for="(item, index) in centro_costos" :key="index + '_centro_costo'" :value="item">{{ item.codigo }} {{ item.descripcion }}</option>
                                    </b-select>
                                </b-field>
                                <b-field label="Fecha de Inicio">
                                    <b-datepicker :append-to-body="true" v-model="reporte.fecha_inicio" :date-formatter="formatDate" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Fecha de Fin">
                                    <b-datepicker :append-to-body="true" v-model="reporte.fecha_fin" :date-formatter="formatDate" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Tipo de Orden">
                                    <b-select multiple native-size="2" expanded v-model="reporte.tipo_ordenes">
                                        <option value="1">Compra</option>
                                        <option value="2">Servicio</option>
                                    </b-select>
                                </b-field>
                            </b-tab-item>
                            <b-tab-item label="Proveedor">
                                <b-field label="Proveedor">
                                    <b-autocomplete placeholder="Proveedor" icon="magnify" clearable v-model="proveedor_search" :data="proveedores" @typing="loadProveedores" field="razon_social"
                                        @select="setProveedor">
                                        <template slot="empty">No results found</template>
                                        <template slot-scope="props">{{ props.option.ruc }} {{ props.option.razon_social }}
                                        </template>
                                    </b-autocomplete>
                                </b-field>
                                <b-field label="Fecha de Inicio">
                                    <b-datepicker :append-to-body="true" v-model="reporte.fecha_inicio" :date-formatter="formatDate" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Fecha de Fin">
                                    <b-datepicker :append-to-body="true" v-model="reporte.fecha_fin" :date-formatter="formatDate" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Tipo de Orden">
                                    <b-select multiple native-size="2" expanded v-model="reporte.tipo_ordenes">
                                        <option value="1">Compra</option>
                                        <option value="2">Servicio</option>
                                    </b-select>
                                </b-field>
                            </b-tab-item>
                            <b-tab-item label="Productos">
                                <b-field label="Categoría del Producto">
                                    <b-select v-model="reporte.categoria_producto.id_categoria_producto" @change.native="loadTiposProducto">
                                        <option value="-1">Todos</option>
                                        <option v-for="(categoria, index) in reporte.categorias_producto" :value="categoria.id_categoria_producto" :key="index + '_categoria'">{{ categoria.descripcion
                                            }}
                                        </option>
                                    </b-select>
                                </b-field>
                                <b-field label="Tipo de Producto">
                                    <b-select v-model="reporte.tipo_producto.id_tipo_producto">
                                        <option value="-1">Todos</option>
                                        <option v-for="(tipo, index) in reporte.tipos_producto" :value="tipo.id_tipo_producto" :key="index + '_tipo_producto'">{{ tipo.descripcion }}</option>
                                    </b-select>
                                </b-field>
                                <b-field label="Fecha de Inicio">
                                    <b-datepicker :append-to-body="true" :date-formatter="formatDate" v-model="reporte.fecha_inicio" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Fecha de Fin">
                                    <b-datepicker :append-to-body="true" :date-formatter="formatDate" v-model="reporte.fecha_fin" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Tipo de Orden">
                                    <b-select multiple native-size="2" expanded v-model="reporte.tipo_ordenes">
                                        <option value="1">Compra</option>
                                        <option value="2">Servicio</option>
                                    </b-select>
                                </b-field>
                            </b-tab-item>
                            <b-tab-item label="Pendientes de Pago">
                                <b-field label="Fecha de Inicio">
                                    <b-datepicker :append-to-body="true" :date-formatter="formatDate" v-model="reporte.fecha_inicio" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Fecha de Fin">
                                    <b-datepicker :append-to-body="true" :date-formatter="formatDate" v-model="reporte.fecha_fin" :position="'is-top-right'"></b-datepicker>
                                </b-field>
                                <b-field label="Tipo de Orden">
                                    <b-select multiple native-size="2" expanded v-model="reporte.tipo_ordenes">
                                        <option value="1">Compra</option>
                                        <option value="2">Servicio</option>
                                    </b-select>
                                </b-field>
                            </b-tab-item>
                        </b-tabs>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="show_reporte_1 = false">
                            Cerrar
                        </button>
                        <button class="button is-primary" @click="generateReport">
                            Generar
                        </button>
                    </footer>
                </div>
            </b-modal>
        </div>
    </div>
    <OrdenCompraReporte2 v-if="show_reporte_2" @close="popup($event)"></OrdenCompraReporte2>
</div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment"
import { purchaseStatus, purchaseType } from "../constants/constants"
import { Button, InputDate, InputSimpleSelect, InputText } from "../modules/components/"
import { ResponseStatus, UsuarioService } from "../rest"
import OpcionesService from "../rest/OpcionesService"
import { Data } from "../util"
import Toast from "../util/toast"
import OrdenCompraReporte2 from "../modules/ordenCompra/OrdenCompraReporte2.vue"
export default {
    name: "OrdenList",
    components: {
        InputText,
        InputDate,
        InputSimpleSelect,
        Button,
        OrdenCompraReporte2,
    },
    data() {
        return {
            show_reporte_1: false,
            show_reporte_2: false,
            filtros_reporte_2: {
                fecha_inicio: null,
                fecha_fin: null
            },
            year: new Date().getFullYear(),
            status: -1,
            type: purchaseType.COMPRA,
            coc_id: null,
            data: [],
            loading: false,
            total: 0,
            search: "",
            timer: null,
            perPage: 10,
            page: 1,
            proveedor_search: "",
            ordenEstado: [],
            paises: [],
            proveedores: [],
            centro_costos: [],
            tipos_orden: [],
            condiciones_comerciales: [],
            reporte: {
                tipo_reporte: 0,
                fecha_inicio: null,
                fecha_fin: null,
                tipo_ordenes: [],
                centro_costos: [],
                categorias_producto: [],
                tipos_producto: [],
                proveedor: { id_proveedor: -1 },
                categoria_producto: { id_categoria_producto: -1 },
                tipo_producto: { id_tipo_producto: -1 }
            },
        }
    },
    computed: {
        usuario() {
            return UsuarioService.getUsuario()
        },
    },
    methods: {
        loadDataTable() {
            let _self = this
            _self.loading = true
            const request = {
                tipo: this.type,
                status: this.status,
                year: this.year,
                search: this.search,
                length: this.perPage,
                coc_id: this.coc_id,
                start: (this.page - 1) * this.perPage,
                proveedores: []
            }
            axios
                .post("/orden/get-orden-list", request)
                .then(
                    response => {
                        _self.data = response.data.data
                        _self.total = response.data.total
                        _self.loading = false
                    },
                    err => {
                        _self.loading = false
                        console.error(err)
                    }
                )
        },
        notifyOrden(idOrden) {
            axios({
                method: "POST",
                url: "/orden/notify",
                headers: { idOrden: idOrden }
            }).then(() =>
                this.$buefy.toast.open({
                    type: "is-success",
                    message: "Se envió la notifiación"
                })
            )
        },
        downloadFile(row) {
            axios({
                method: "GET",
                responseType: "blob",
                url: "/orden/download",
                headers: { idOrden: row.id }
            }).then(response => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]))
                let fileLink = document.createElement("a")
                fileLink.href = fileURL
                fileLink.setAttribute("download", `${row.codigo}.pdf`)
                document.body.appendChild(fileLink)
                fileLink.click()
            })
        },
        deleteOrden(id) {
            this.$buefy.dialog.confirm({
                title: "Anulación de Orden",
                message: "Estas seguro de <b>Anular</b> la Orden",
                confirmText: "Anular",
                type: "is-danger",
                hasIcon: true,
                onConfirm: () => {
                    axios
                        .post("/orden/delete-orden", {
                            id_orden: id
                        })
                        .then(
                            () => {
                                this.loadDataTable()
                                this.$buefy.toast.open("Orden Anulada")
                            },
                            error => console.error(error)
                        )
                }
            })
        },
        refreshData() {
            this.loadDataTable()
        },
        searchData() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            let _self = this
            this.timer = setTimeout(() => _self.loadDataTable(), 1000)
        },
        onPageChange(page) {
            this.page = page
            this.loadDataTable()
        },
        loadOrdenesEstado() {
            let _self = this
            axios.get("/orden/estado/list").then(
                response => {
                    _self.ordenEstado.push({
                        id_orden_estado: -1,
                        descripcion: "Todos"
                    })
                    response.data.forEach(item => {
                        _self.ordenEstado.push(item)
                    })
                },
                err => {
                    console.error(err)
                }
            )
        },
        getOrdenColor(status) {
            let estado = this.ordenEstado.find(
                estado => estado.descripcion === status
            )
            const values = Object.values(purchaseStatus)
            let response = "is-light"
            if (estado) {
                values.forEach(e => {
                    if (e.id === estado.id_orden_estado) {
                        response = e.class
                    }
                })
            }
            return response
        },
        getPais(id_pais) {
            if (id_pais) {
                let pais = this.paises.filter(pais => pais.id_pais === id_pais)
                return pais ? pais[0].nombre : ""
            }
            return ""
        },
        loadPaises() {
            let _self = this
            axios.get("/pais/list").then(
                res => (_self.paises = res.data),
                err => console.error(err)
            )
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        generateReport() {
            let report = {
                fecha_inicio: this.reporte.fecha_inicio,
                fecha_fin: this.reporte.fecha_fin,
                tipo_reporte: this.reporte.tipo_reporte,
                tipo_ordenes: this.reporte.tipo_ordenes,
                centro_costos: this.reporte.centro_costos,
                proveedor: this.reporte.proveedor,
                categoria_producto: this.reporte.categoria_producto,
                tipo_producto: this.reporte.tipo_producto
            }
            report.fecha_fin = this.formatDate(report.fecha_fin)
            report.fecha_inicio = this.formatDate(report.fecha_inicio)
            axios({
                method: "POST",
                responseType: "blob",
                url: "/orden/report",
                data: report
            }).then(resp => {
                let fileURL = window.URL.createObjectURL(new Blob([resp.data]))
                let fileLink = document.createElement("a")
                fileLink.href = fileURL
                fileLink.setAttribute("download", `reporte.xlsx`)
                document.body.appendChild(fileLink)
                fileLink.click()
            })
        },
        loadProveedores: _.debounce(function (text) {
            axios.post("/proveedor/get-proveedor", { razon_social: text }).then(
                response => (this.proveedores = response.data),
                error => console.error(error)
            )
        }, 500),
        setProveedor(option) {
            this.reporte.proveedor.id_proveedor = option.id_proveedor
        },
        loadCentroCosto() {
            // axios.post("/opciones/getCentrosCosto", { cec_descripcion: "" }).then(
            //     response => (this.centro_costos = response.data),
            //     error => console.error(error)
            // )
            OpcionesService.getCentrosCosto({
                centro_costo: {
                    cec_descripcion: ""
                }
            }).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.centro_costos = response.data
                }
                else {
                    Toast.warn(response.message)
                }
            }).catch(error => {
                Toast.error(error)

            })
        },
        loadCategorias() {
            axios
                .get("/categoria-producto/list")
                .then(res => (this.reporte.categorias_producto = res.data))
        },
        loadTiposProducto() {
            this.tipo_producto = -1
            axios
                .get(
                    "/tipo-producto/get-categoria?id_categoria=" +
                    this.reporte.categoria_producto.id_categoria_producto
                )
                .then(res => (this.reporte.tipos_producto = res.data))
        },
        loadCondicionesComerciales() {
            this.condiciones_comerciales.push({
                coc_id: -1,
                coc_descripcion: "Todos"
            })
            Data.get(Data.listNames.condiciones_comerciales).forEach(item => {
                this.condiciones_comerciales.push(item)
            })
        },
        roles() {
            if (localStorage.getItem("user"))
                return this.usuario.roles
            else return ""
        },
        isVisualizador() {
            return this.roles() === "VISUALIZADOR"
        },
        showPagar(orden) {
            if (this.usuario.roles.indexOf("CONTABILIDAD") > -1) {
                if (orden.id_orden_estado === purchaseStatus.EMITIDO.id) {
                    return true
                } else if (orden.id_orden_estado === purchaseStatus.APROBACION_GERENCIA.id) {
                    return false
                }
            }
            return false
        },
        pagarOrden(idOrden) {
            // axios({
            //     method: "POST",
            //     url: "/orden/approve",
            //     headers: {
            //         idOrden
            //     },
            //     data: {
            //         id_orden_estado: purchaseStatus.PAGADO.id
            //     }
            // }).then(() => {
            //     Toast.success("La orden ha sido pagada")
            // })
        },
        popup({
            interfaz,
            activar,
        }) {
            switch (interfaz) {
                case "OrdenCompraReporte2":
                    this.show_reporte_2 = activar
                    break
            }
        },
    },
    mounted() {
        this.loadPaises()
        this.loadCentroCosto()
        this.loadCategorias()
        this.loadCondicionesComerciales()
        this.tipos_orden = [{ id: 1, nombre: "Compra" }, { id: 2, nombre: "Servicio" }]
        this.loadOrdenesEstado()
        this.loadDataTable()
    }
}
</script>

<style scoped></style>
